// extracted by mini-css-extract-plugin
export var column = "drawer-module--column--dfc39";
export var content = "drawer-module--content--7e2c4";
export var drawer = "drawer-module--drawer--50be8";
export var drilldown = "drawer-module--drilldown--aad2b";
export var list = "drawer-module--list--87d04";
export var lower = "drawer-module--lower--66bd1";